import jquery from 'jquery';
import EFOcats_event_core from './efocats_event_core.js';

/**
 * ページ離脱イベント
 */
export default class EFOcats_event_leave extends EFOcats_event_core {
  /**
   * イベント本体をセット
   */
  event() {
    jquery(window).on('unload.attention', () => {
      if (efocats.open_modal) {
        efocats.submit.data_submit();
      }
    });
  }
}
